import { ServiceState } from 'components/system/models/ServiceState';

define((require, exports, module) => {
    'use strict';

    const Service = require('system/Service');
    const InfraServiceModel = require('./models/InfraProject');

    const InfraService = Service.extend({
        name: 'infra',

        serviceAvailabilityFeatureName: 'CLOUD_SERVERS_SERVICE',

        constructor: function InfraService() {
            InfraService.parent.call(this, {
                serviceState: new ServiceState({
                    createSingleModelInstance: () => new InfraServiceModel(),
                    fetchSingleModelInstance: () => InfraServiceModel.findOne(),
                }),
            });
        },

        getPid() {
            const model = this.getModel();
            let pid;

            if (model) {
                pid = model.get('os_project_id');
            } else {
                pid = '';
            }

            return pid;
        },

        getHorizonUrl() {
            let url;
            const model = this.getModel();

            if (model) {
                url = model.get('dashboard_url');
            } else {
                url = 'https://infra.mail.ru/';
            }

            return url;
        },

        isProtected() {
            const model = this.getModel();
            if (model) {
                return !!model.get('protected');
            }
            return false;
        },
    });

    module.exports = InfraService;
});
